
import lockIcon from "../../assets/lock.svg"
import {PhoneHQButton} from 'ch3-ui-lib';
import {Link} from "react-router-dom";

const AdminPanelRestrictedView = () => {


    return (
<>
        <div  className={`flex h-full w-full`}>
            <div className={'w-full overflow-y-auto  h-[calc(100vh-63px-var(--header-height))]'}  >

            <div className='flex text-center  justify-center items-center  h-full'>
                    <div className='  '>
                        <div className='flex  justify-center w-full'>
                            <img className='m-4' src={lockIcon}/>
                        </div>
                        <h1 className='font-bold text-5xl mb-2'>
                        Access restricted
                        </h1>
                        <div >
                        This section is available only to Admin Users. 
                        
                        </div>
                        <div className='mb-6'>
                        
                        Your account does not have sufficient permissions.
                        </div>
                        <div className='flex justify-center'>
                                    <Link to={'/calls'}>
                                        <PhoneHQButton>Return to User panel</PhoneHQButton>
                                    </Link>

                         </div>
                    </div>
                </div>


            </div>

            

           
        </div>

    </>
    );
};

export const RestrictedView = () => {

    return (
        <>
            <div  className={`flex h-full w-full`}>
                <div className={'w-full overflow-y-auto  h-[calc(100vh-63px-var(--header-height))]'}  >

                    <div className='flex text-center  justify-center items-center  h-full'>
                        <div className='  '>
                            <div className='flex  justify-center w-full'>
                                <img className='m-4' src={lockIcon}/>
                            </div>
                            <h1 className='font-bold text-5xl mb-2'>
                                Access restricted
                            </h1>
                            <div >
                                This section is available only to regular users.

                            </div>
                            <div className='mb-6'>

                                Your account does not have sufficient permissions.
                            </div>
                            <div className='flex justify-center'>
                                <Link to={'/'}>
                                    <PhoneHQButton>Return to Admin panel</PhoneHQButton>
                                </Link>

                            </div>
                        </div>
                    </div>


                </div>




            </div>

        </>
    );
};

export default AdminPanelRestrictedView;